import { Action, createReducer, on } from '@ngrx/store';
import {
  toggleSidebar,
  closeSidebar,
  openSidebar
} from './../actions/sidebar.actions';

const initialState: any = {
  toggle: true, // sidebar abierto por defecto al autenticar
  home: true
};

const sidebarReducer = createReducer(
  initialState,
  on(toggleSidebar, state => ({
    ...state,
    toggle: !state.toggle
  })),
  on(closeSidebar, state => ({
    ...state,
    toggle: false
  })),
  on(openSidebar, state => ({
    ...state,
    toggle: true
  })),
);

export function SidebarReducer(state: boolean | undefined, action: Action) {
  return sidebarReducer(state, action);
}
